import { faMegaphone } from "@fortawesome/pro-duotone-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconButton, Tooltip } from "@mui/material";
import * as Sentry from "@sentry/react";
import { useEffect, useRef } from "react";

const ToggleFeedbackButton = () => {
    const feedbackRef = useRef(Sentry.getFeedback());
    const buttonRef = useRef<HTMLButtonElement | null>(null);

    useEffect(() => {
        if (!buttonRef.current) return;

        const unsubscribe = feedbackRef.current?.attachTo(buttonRef.current, {
            colorScheme: "light",
        });

        return () => {
            unsubscribe?.();
        };
    }, []);

    return (
        <Tooltip title="Report a Bug">
            <IconButton aria-label="report bug" color="inherit" ref={buttonRef}>
                <FontAwesomeIcon icon={faMegaphone} fixedWidth />
            </IconButton>
        </Tooltip>
    );
};
export default ToggleFeedbackButton;
